import { Schema } from "@generation/core";
import { CreateKlantcontactCommand } from "@klantondersteuning/client/src/client.generated.klantcontactService";
import { RequestInformation, SchemaToRequestMapper } from "@klantondersteuning/shared";

export class StopzettenBroninhoudingSchemaToRequestMapper extends SchemaToRequestMapper {
  constructor() {
    super();
  }
  map(
    flowSteps: Schema[],
    formulier: any,
    language: string,
    formulierKenmerk: string,
    onderwerp: string,
    requestInformation?: RequestInformation
  ): Promise<CreateKlantcontactCommand> {
    const kenmerk =
      formulier.stap_mijnverzoek__aanleiding.herinneringOfAanmaning === "ja"
        ? "stopzetten-broninhouding-aanleiding-herinnering-form"
        : formulierKenmerk;

    return super
      .map(flowSteps, formulier, language, formulierKenmerk, onderwerp, requestInformation)
      .then((command: CreateKlantcontactCommand) => {
        command.formulier.sleutel = kenmerk;
        return command;
      });
  }
}
